import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Slide, ToastContainer as ToastContainerBase, toast as toastify, } from "react-toastify";
import Spacer, { ESpacerWeight } from "../../components/components/Spacer";
import * as S from "./Toast.styled";
var typeClassNameMap = {
    info: "toastify-rentio-info",
    error: "toastify-rentio-error",
    success: "toastify-rentio-success",
};
var typeProgressClassNameMap = {
    info: "toastify-info-rentio-info",
    error: "toastify-error-rentio-error",
    success: "toastify-success-rentio-success",
};
// @deprecated Use `showAlert` instead
export var toast = function (props) {
    var type = props.type, heading = props.heading, content = props.content;
    var renderContent = function (_) { return (_jsxs(S.ToastWrap, { children: [_jsx(S.Heading, { children: heading }), content && (_jsxs(_Fragment, { children: [_jsx(Spacer, { weight: ESpacerWeight.W04 }), _jsx(S.Content, { children: content })] }))] })); };
    toastify(renderContent, {
        type: type,
        closeButton: true,
        autoClose: 10000,
        closeOnClick: false,
        transition: Slide,
        // customProgressBar: true,
        className: typeClassNameMap[type],
        progressClassName: typeProgressClassNameMap[type],
    });
};
export var ToastContainer = function () { return (_jsxs(_Fragment, { children: [_jsx(S.CustomToastStyles, {}), _jsx(ToastContainerBase, { style: { zIndex: 9999999 } })] })); };
